module.exports = __webpack_public_path__ + "img/spiral-dough.84b75b6a.svg";